import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Santacruztopunecab() {



const cardData = {
  keyword: " Santacruz to Pune Cabs",

headingDescription: "Velocity Cab provides reliable and comfortable Santacruz to Pune cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Santacruz to Pune convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Santacruz to Pune cab travel.",

topPlaces: [
 
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva located in the heart of Pune. Travelers using a Santacruz to Pune cab can visit this peaceful historical site known for its unique architecture."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum houses a remarkable collection of Indian artifacts including sculptures, musical instruments, and decorative items. Visitors from Santacruz can explore Pune’s rich cultural heritage through this museum."
  },
  {
    title: "Parvati Hill Temple",
    description: "Parvati Hill Temple is one of the oldest heritage sites in Pune offering panoramic views of the city. Travelers arriving from Santacruz by cab often climb the hill to enjoy scenic beauty and visit the historic temples."
  },
  {
    title: "Khadakwasla Dam",
    description: "Khadakwasla Dam is a popular getaway near Pune known for its serene water views and surrounding hills. Travelers from Santacruz often visit this relaxing spot for photography and peaceful sunsets."
  },
   {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is a historic fortification in Pune that once served as the seat of the Peshwas of the Maratha Empire. Travelers using a Santacruz to Pune cab often visit this landmark to explore its grand gates, historical ruins, and cultural significance."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is one of Pune’s most important historical landmarks associated with India’s freedom movement and Mahatma Gandhi. Visitors traveling from Santacruz by cab can explore its elegant architecture, peaceful gardens, and museum."
  },
  {
    title: "Sinhagad Fort",
    description: "Sinhagad Fort is a famous hill fortress located on the outskirts of Pune, known for its scenic views and Maratha history. Travelers arriving from Santacruz by cab often include this destination for trekking and enjoying breathtaking landscapes."
  },
  {
    title: "Dagdusheth Halwai Ganpati Temple",
    description: "Dagdusheth Halwai Ganpati Temple is one of the most revered temples in Pune dedicated to Lord Ganesha. Visitors traveling from Santacruz by cab frequently stop here to seek blessings and experience the spiritual atmosphere."
  },
  {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden, also called Pu La Deshpande Garden, is a beautifully designed Japanese-style garden. Visitors traveling from Santacruz by cab can enjoy its calm atmosphere, walking paths, and lush greenery."
  },
  {
    title: "Lal Mahal",
    description: "Lal Mahal is a historic palace associated with the childhood of Chhatrapati Shivaji Maharaj. Travelers using a Santacruz to Pune cab can visit this important landmark to learn about Pune’s rich Maratha history."
  }
],



services: [
{
name: "Santacruz to Pune Taxi Fare",
description: "Santacruz to Pune taxi fare service provides transparent pricing for passengers traveling between Santacruz in Mumbai and Pune city. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth travel via the Mumbai–Pune Expressway. Professional drivers offer punctual pickup from homes, hotels, railway stations, and airport terminals around Santacruz."
},
{
name: "Santacruz Airport to Pune Taxi Fare",
description: "Santacruz Airport to Pune taxi fare service offers affordable pricing for passengers traveling from Mumbai Airport area to Pune city. Comfortable vehicles ensure smooth highway travel for airport passengers."
},
{
name: "Santacruz Airport to Pune One Way Taxi",
description: "Santacruz Airport to Pune one way taxi service provides convenient single-trip airport transportation without return charges. Vehicles provide comfortable seating and luggage space suitable for airport travel."
},
{
name: "Mumbai to Pune Cab Booking",
description: "Mumbai to Pune cab booking service allows passengers to easily reserve taxis for travel between Mumbai and Pune. Flexible booking options ensure convenient travel planning with comfortable vehicles."
},
{
name: "Santacruz Airport to Pune Taxi Service",
description: "Santacruz Airport to Pune taxi service offers reliable airport transfer transportation between Mumbai Airport and Pune city with professional drivers ensuring safe journeys."
},
{
name: "Santacruz to Pune by Taxi",
description: "Santacruz to Pune by taxi service provides dependable intercity transportation between Mumbai and Pune. Comfortable vehicles and experienced drivers ensure smooth expressway travel."
},
{
name: "Santacruz to Pune Innova Crysta",
description: "Santacruz to Pune Innova Crysta service offers premium SUV transportation with spacious seating and smooth highway performance suitable for families and corporate travelers."
},
{
name: "Santacruz to Pune Ertiga Taxi",
description: "Santacruz to Pune Ertiga taxi service provides comfortable 7-seater SUV transportation ideal for families and small groups traveling between Mumbai and Pune."
},
{
name: "Santacruz to Pune Sedan Taxi",
description: "Santacruz to Pune sedan taxi service offers economical transportation using vehicles like Swift Dzire and Etios suitable for individuals and small families."
},
{
name: "Mumbai International Airport to Pune Cab",
description: "Mumbai International Airport to Pune cab service offers convenient airport transfers between Chhatrapati Shivaji Maharaj International Airport and Pune city."
},
{
name: "Cab Service in Santacruz West",
description: "Cab service in Santacruz West provides reliable transportation for city rides, airport transfers, and outstation journeys across Mumbai."
},
{
name: "Best Cab Service in Santacruz",
description: "Best cab service in Santacruz offers dependable transportation with comfortable vehicles and professional drivers for local travel and outstation journeys."
},
{
name: "Santacruz Airport Cab Service",
description: "Santacruz airport cab service provides convenient airport transportation for arrivals and departures at Mumbai Airport terminals."
},
{
name: "Santa Cruz Airport Car Service",
description: "Santa Cruz airport car service offers reliable vehicle transportation for passengers traveling to and from Mumbai Airport."
},
{
name: "Innova Crysta on Rent in Santacruz",
description: "Innova Crysta on rent in Santacruz offers premium SUV transportation with spacious interiors and comfortable highway travel."
},
{
name: "Ertiga on Rent in Santacruz",
description: "Ertiga on rent in Santacruz provides comfortable 7-seater SUV transportation suitable for family trips and airport transfers."
},
{
name: "Taxi Service in Santacruz",
description: "Taxi service in Santacruz offers dependable transportation for city rides, airport transfers, and outstation travel across Mumbai."
},
{
name: "Cab Service in Mumbai City",
description: "Cab service in Mumbai city provides reliable transportation for passengers traveling across Mumbai and nearby destinations like Pune."
},
{
name: "Santacruz to Pune Cab",
description: "Santacruz to Pune cab service offers dependable intercity transportation between Mumbai and Pune with comfortable vehicles."
},
{
name: "Santacruz to Pune Taxi",
description: "Santacruz to Pune taxi service provides safe and convenient travel options for passengers traveling between Mumbai and Pune."
},
{
name: "Santacruz to Pune Cab Service",
description: "Santacruz to Pune cab service offers reliable transportation between the two cities with professional drivers and comfortable vehicles."
},
{
name: "Santacruz to Pune Taxi Service",
description: "Santacruz to Pune taxi service provides convenient intercity transportation with smooth highway travel."
},
{
name: "Santacruz to Pune Cab Booking",
description: "Santacruz to Pune cab booking service allows passengers to easily reserve taxis for intercity travel between Mumbai and Pune."
},
{
name: "Cab from Santacruz to Pune",
description: "Cab from Santacruz to Pune provides convenient door-to-door transportation with comfortable vehicles and experienced drivers."
}
],

tableData: [
["Santacruz to Pune Taxi Fare","Santacruz Airport to Pune Taxi Fare"],
["Santacruz Airport to Pune One Way Taxi","Mumbai to Pune Cab Booking"],
["Santacruz Airport to Pune Taxi Service","Santacruz to Pune by Taxi"],
["Santacruz to Pune Innova Crysta","Santacruz to Pune Ertiga Taxi"],
["Santacruz to Pune Sedan Taxi","Mumbai International Airport to Pune Cab"],
["Cab Service in Santacruz West","Best Cab Service in Santacruz"],
["Santacruz Airport Cab Service","Santa Cruz Airport Car Service"],
["Innova Crysta on Rent in Santacruz","Ertiga on Rent in Santacruz"],
["Taxi Service in Santacruz","Cab Service in Mumbai City"],
["Santacruz to Pune Cab","Santacruz to Pune Taxi"],
["Santacruz to Pune Cab Service","Santacruz to Pune Taxi Service"],
["Santacruz to Pune Cab Booking","Cab from Santacruz to Pune"]
],





whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who frequently travel from Santacruz to Pune via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic conditions ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Santacruz to Pune cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Santacruz to Pune cab service operates 24 hours a day. Whether you need an early morning ride, airport transfer, or late night travel, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Santacruz to Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Santacruz",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, airports, railway stations, and residential areas across Santacruz including Santacruz East, Santacruz West, and nearby locations."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Santacruz to Pune cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Santacruz to Pune cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Santacruz to Pune with professional drivers and comfortable vehicles." },
  { question: "How far is Santacruz from Pune?", answer: "The road distance between Santacruz and Pune is approximately 150 km and the journey usually takes about 3 to 4 hours depending on traffic." },
  { question: "Is Santacruz to Pune cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Santacruz to Pune travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Santacruz to Pune?", answer: "Yes, we provide both one-way and round-trip cab services between Santacruz and Pune." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, airports, and residential areas across Santacruz." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Santacruz to Pune cab services online or through phone booking." },
  { question: "Do you provide drop service to Pune Airport or railway station?", answer: "Yes, Velocity Cabs provides drop services to Pune Airport, railway stations, and major locations across Pune." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sameer Khanna",
    feedback:
      "Santacruz to Pune cab service with Velocity Cab was smooth and comfortable. The car was clean, and the journey felt safe and well-managed throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Radhika Menon",
    feedback:
      "The Santacruz to Pune cab ride with Velocity Cab was very reliable. The driver was professional, and the trip was punctual and hassle-free.",
    rating: 5
  }
];



































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Santacruz to Pune Cab Service | Velocity Cabs",
  "description": "Velocity Cabs provides reliable Santacruz to Pune cab service with affordable fares and professional drivers. Book one way and round trip taxis including Innova, Innova Crysta, Ertiga, and Sedan cabs for airport transfers, city-to-city travel, and corporate trips. Enjoy safe, comfortable, and punctual rides with easy online booking from Santacruz to Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};




  return (
    <div>
      
<Helmet>
  <title>Santacruz to Pune Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Santacruz to Pune cab with Velocity Cabs. Affordable one way & round trip taxis including Innova, Innova Crysta, Ertiga & Sedan for airport transfers, city-to-city travel & corporate trips." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/36.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Santacruztopunecab;